import posthog from 'posthog-js';

let initialized = false;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


export const initPostHog = () => {
    if (initialized) {
        return true;
    }

    try {
        const postHogKey = import.meta.env.VITE_POSTHOG_KEY;
        const anonymousId = getCookie('ph_anon_id');
        const sessionId = getCookie('ph_session_id');
        const userId = localStorage.getItem('user_id') || undefined;



        if (!postHogKey) {
            console.error("PostHog API key is missing. Events will not be captured.");
            return false;
        }

        posthog.init(postHogKey, {
            api_host: 'https://t.instavault.co',
            autocapture: true,
            capture_pageview: true,
            capture_pageleave: true,
            persistence: 'localStorage+cookie', // Use both for cross-subdomain
            person_profiles: 'identified_only',
            session_recording: {
                recordCrossOriginIframes: true
            },
            ...(anonymousId && !userId && { bootstrap: { distinctID: anonymousId, sessionID: sessionId } }),
            loaded: function () {
                console.log("PostHog initialized successfully");
            }
        });

        initialized = true;
        return true;
    } catch (error) {
        console.error("Error initializing PostHog:", error);
        return false;
    }
};

export const captureEvent = (eventName: string, properties?: Record<string, any>) => {
    try {
        // Ensure PostHog is initialized
        if (!initialized) {
            const success = initPostHog();
            if (!success) {
                console.error(`Failed to capture event "${eventName}" - PostHog not initialized`);
                return;
            }
        }

        posthog.capture(eventName, properties);

    } catch (error) {
        console.error(`Error capturing PostHog event "${eventName}":`, error);
    }
};

export default {
    initPostHog,
    captureEvent
}; 